<div class="issues">
    <toggler
            class="click-toggler"
        @toggle="hideShow"
        :do-not-change="loading"
    />
    <div class="issues__content" v-if="isShow">
        <div v-if="!currentInfo.length">
            <placeholder :amount="1" :rows="num || 3" />
        </div>
        <div v-else-if="error">{{error}}</div>

        <ul v-else
            class="issues__content loaded"
        >
            <issue
                    v-for="i in currentInfo"
                    :key="i"
                    :username="i.user.login"
                    :issue="i.title"
            />
        </ul>
    </div>
</div>
